import ArrowRight from '@assets/icons/arrow-right.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { Text, TouchableOpacity, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

export const LIST_ITEM_HEIGHT = 40;
export const LIST_ITEM_MARGIN = 24;

interface Props {
  alertText: string;
  onPress: () => void;
}

export const AnalyticsAlert: React.FC<Props> = ({ alertText, onPress }) => {
  const [styles, theme] = useStyles();
  return (
    <TouchableOpacity disabled={!onPress} onPress={onPress}>
      <View style={styles.base}>
        <View style={styles.row}>
          <Text style={TYPOGRAPHY.pSemiBold}>{alertText}</Text>
          <View style={styles.icon}>
            <ArrowRight fill={theme.colors.primary} />
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.stroke,
    borderRadius: 4,
    borderWidth: 1,
    height: LIST_ITEM_HEIGHT,
    justifyContent: 'center',
    marginHorizontal: LIST_ITEM_MARGIN,
  },
  icon: {
    opacity: 1,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingHorizontal: 8,
  },
}));
